/**
 * 计算页面rem
 * @param windowObj
 * @param htmlDom
 */
export const initRem = (window, document) => {
  const docEl = document.documentElement;
  // const bodyEl = document.body;
  const dpr = window.devicePixelRatio || 1;
  // 根据不同dpr调整body字体大小
  // function setBodyFontSize() {
  //   if (bodyEl) {
  //     bodyEl.style.fontSize = `${12 * dpr}px`;
  //   } else {
  //     document.addEventListener('DOMContentLoaded', setBodyFontSize);
  //   }
  // }
  // setBodyFontSize();
  // 设置根元素字体大小
  function setRemUnit() {
    let rem = 192;
    // 最大显示宽度限制
    // 当页面可见的宽度大于1920px时按照1920px处理;
    // rem = docEl.clientWidth / 100;
    if (window.innerWidth >= 1000) {
      rem = window.innerWidth / 100;
    } else {
      rem = window.innerWidth / 19.5;
    }
    docEl.style.fontSize = `${rem}px`;
  }
  setRemUnit();
  // 监听网页resize事件并重新计算rem
  window.addEventListener('resize', setRemUnit);
  window.addEventListener('pageshow', (e) => {
    if (e.persisted) {
      setRemUnit();
    }
  });
  // 检测支持0.5px
  if (dpr >= 2) {
    const fakeBody = document.createElement('body');
    const testElement = document.createElement('div');
    testElement.style.border = '.5px solid transparent';
    fakeBody.appendChild(testElement);
    docEl.appendChild(fakeBody);
    if (testElement.offsetHeight === 1) {
      docEl.classList.add('hairlines');
    }
    docEl.removeChild(fakeBody);
  }
};
